// extracted by mini-css-extract-plugin
module.exports = {"daily":"DailyWeather_daily__1CR-8","card":"DailyWeather_card__3eLQR","icon":"DailyWeather_icon__1kvEX","temp":"DailyWeather_temp__ecWLE"};